import PropTypes from '../_util/vue-types';

export default {
  name: 'ATableColumnGroup',
  props: {
    title: PropTypes.any,
  },
  __ANT_TABLE_COLUMN_GROUP: true,
};
